<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div no-body class="mb-1" style="width: 100%; position: relative;" ref="selectFormasPago" v-b-tooltip.hover.topleft.v-light>
      <div class="scrollable-container-tratamientos barras d-flex " style="margin-top: 0px;">
        <div class="barras d-flex" style="margin-top: 0px" v-for="(formaAgregada,posicion) in formasPago"  :key="formaAgregada.idFormaPago + '-' + posicion">
          <span>{{formaAgregada.nombreForma}}</span>
          <b-icon @click="limpiarFormaPago(posicion)" class="mr-2" variant="lg" font-scale="1.2" v-if="!formaBuscada.collapseOpen" icon="x" :rotate="formaBuscada.collapseOpen ? 180 : 0"></b-icon>
        </div>
        <b-form-input class="input-filter" v-model="formaBuscada.nombreForma" @click="toggleCollapse" type="text" @input="buscarFormaPago()" @keydown.enter.prevent="buscarFormaPago()">
          <p v-if="formasPago.length === 0">Selecciona una forma de pago</p>
        </b-form-input>
        <b-icon icon="chevron-down" font-scale="1.1" :rotate="formaBuscada.collapseOpen ? 180 : 0" @click="toggleCollapse"></b-icon>
      </div>
      <b-collapse class="floating-collapse text-left" :id="'selectFormaPago'" v-model="formaBuscada.collapseOpen"
                  accordion="selectFormaPago-accordion" role="selectFormaPagopanel" style="border: 1px solid #D0D0D0; background-color: white; position: absolute; left: 0; width: 100%; height: 100%;"
                  ref="selectFormaPago-collap"
      >
        <ul id="listaFormasPago" style="margin-left: 0px; overflow-y: scroll; padding-left: 15px;" :style="resultadosBusquedaFiltro.length > 8 ? 'height: 15em;' : 'height: auto;'">
          <li v-for="(formasDePago, index) in resultadosBusquedaFiltro" :key="index+'-'+formasDePago.nombreForma">
            <div v-if="formasDePago.idFormaPago === 7" class="d-flex" @click="toggleBranch(formasDePago)">
              <b-icon style="margin-right: .3em; margin-top: 2%;" icon="chevron-down" :rotate=" formasDePago.isOpen ? 180 : 0"></b-icon>
              <p class="mt-2">{{ formasDePago.nombreForma}}</p>
            </div>
            <div v-else class="d-flex align-items-center" @click="seleccionarForma(formasDePago)">
              <p class="mt-3">{{ formasDePago.nombreForma }}</p>
            </div>

            <div v-if="formasDePago.isOpen" :class="{ 'nested': true, 'active': formasDePago.isOpen }">
              <ul v-for="(financiera, indexFinanciera) in catalogoFinancieras" :key="financiera.idFinanciera + '-' + indexFinanciera">
                <span @click="seleccionarFinanciera(financiera)">{{ financiera.financiera }}</span>
              </ul>
            </div>
          </li>
        </ul>
      </b-collapse>
    </div>
  </div>
</template>

<script>


export default {
  name: "SelectFormasPago",
  components: {},
  props: {
    catalogoFormasPago: Array,
    catalogoFinancieras: Array,
    formasPago: Array,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      formaBuscada: {
        nombreForma: null,
        collapseOpen: false
      },
      formasOrganizados: null,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  validations: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.organizarFormas();
  },
  watch: { },
  computed: {},
  methods: {
    toggleCollapse(event) {
      event.stopPropagation();
      this.formaBuscada.collapseOpen = !this.formaBuscada.collapseOpen;
    },

    handleClickOutside(event) {
      const domNode = this.$refs.selectFormasPago;
      if (!domNode || !domNode.contains(event.target)) {
        this.formaBuscada.collapseOpen = false;
      }
    },

    limpiarFormaPago(index){
      this.formasPago.splice(index,1);
    },

    seleccionarForma(data){
      if(data != null && !this.formasPago.includes(forma=>forma.idFormaPago === data.idFormaPago)){
        let agregarForma = {
          nombreForma: data.nombreForma,
          idFormaPago: data.idFormaPago,
          idFinanciera: null
        }
        this.formasPago.push(agregarForma);
      }
      this.closeCollapse();
    },

    seleccionarFinanciera(data){
      if(data != null){
        let agregarForma = {
          nombreForma: data.financiera,
          idFormaPago: 7,
          idFinanciera: data.idFinanciera
        }
        this.formasPago.push(agregarForma);
      }
      this.closeCollapse();
    },

    closeCollapse(){
      this.formaBuscada.collapseOpen = false;
    },

    buscarFormaPago() {
      this.formaBuscada.collapseOpen = false;
      this.resultadosBusquedaFiltro = this.buscar(this.formasOrganizados)
      this.formaBuscada.collapseOpen = true;
    },

    buscar(forma) {
      return forma.filter(p => {
        if (p.nombreForma.toLowerCase().includes(this.formaBuscada.nombreForma.toLowerCase().trim())){
          return true;
        }
      })
    },

    organizarFormas() {
      this.formasOrganizados = this.catalogoFormasPago
      this.resultadosBusquedaFiltro = this.formasOrganizados
    },

    toggleBranch(forma) {
      forma.isOpen = !forma.isOpen;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
p {
  color: #6f6f6f;
}
.floating-collapse {
  border-radius: 5px;
  z-index: 1000;
}
.barras {
  border-width: 1px;
  border-style: solid;
  border-color: #d1d0d0;
  background: #ffffff;
  margin-top: 20px;
  padding-right: 1%;
  padding-left: 1%;
  border-radius: 5px;
  text-align: left;
  align-items: center;
}

.scrollable-container-tratamientos {
  overflow-y: auto;
  max-height: 105px;
}

ul, #myUL {
  list-style-type: none;
}

.nested {
  display: none;
}

.active {
  display: block;
}
</style>